import axios from "axios";

const API = axios.create({
  baseURL: "https://surajai.synovats.com/api"
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  console.log("TOKEN:", token);

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  console.log("HEADERS:", config.headers);

  return config;
});

export default API;